import React from 'react';
import { User } from 'lucide-react';

interface UserAvatarProps {
  avatarUrl?: string;
  name?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ 
  avatarUrl, 
  name,
  size = 'sm',
  className = ''
}) => {
  const sizeClasses = {
    sm: 'w-5 h-5',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  };

  const iconSizeClasses = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-6 h-6'
  };

  if (avatarUrl) {
    return (
      <div className={`${sizeClasses[size]} ${className} rounded-full overflow-hidden bg-gray-100 flex items-center justify-center`}>
        <img 
          src={avatarUrl} 
          alt={name || 'User avatar'} 
          className="w-full h-full object-cover"
        />
      </div>
    );
  }

  return (
    <div className={`${sizeClasses[size]} ${className} rounded-full bg-gray-200 flex items-center justify-center`}>
      <User className={`${iconSizeClasses[size]} text-gray-500`} />
    </div>
  );
};

export default UserAvatar;






